<template>
  <div class="relative inline-block text-left" v-on-clickaway="close">
    <button class="relative z-10 w-full rounded" @click="open = !open">
      <slot />
    </button>

    <transition
      enter-active-class="transition duration-100 ease-out"
      leave-active-class="transition duration-75 ease-in"
      enter-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
      appear>
      <div v-if="open" class="absolute z-50 mt-2 rounded-md shadow-lg" 
        :class="[dropdownClass, { 'right-0 origin-top-right': align === 'right', 'left-0 origin-top-left': align === 'left' }]">
        <slot name="dropdown" />
      </div>
    </transition>
  </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway'

  export default  {
    name: 'Dropdown',

    mixins: [ clickaway ],

    props: {
      align: {
        type: String,
        default: 'right'
      },

      dropdownClass: {
        type: String
      }
    },

    data () {
      return {
        open: false
      }
    },

    methods: {
      close () {
        if (this.open) {
          this.open = false
        }
      }
    }
  }
</script>